import React, { useState } from 'react';
import { FaRegEyeSlash, FaTrash } from "react-icons/fa";
import Footer from '../Footer/Footer';
import { NavLink } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";


export const AccountSettings = () => {
  const [activeTab, setActiveTab] = useState('activepost');

  const [companies, setCompanies] = useState([
    {
      id: 1,
      logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
      title: "Veritis Group Inc.",
      leads: 120,
      impressions: 200,
      rating: 4.8,
      tagline: "Innovating the Future",
      servicesCount: 10,
      productCount: 5,
      verified: true,
    },
    {
      id: 2,
      logo: "https://www.wipro.com/content/dam/wipro/social-icons/wipro_new_logo.svg",
      title: "Wipro",
      leads: 90,
      impressions: 50,
      rating: 4.7,
      tagline: "Your Digital Partner",
      servicesCount: 8,
      productCount: 3,
      verified: false,
    },
  ]);

  const [showModal, setShowModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const handleDelete = (id) => {
    setCompanies(companies.filter((company) => company.id !== id));
    setShowModal(false);
  };





  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <>
    <div className="js-pg-hg mt-4">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="heading mb-3 mt-4 pb-1">
            <h4>Account Settings</h4>
          </div>
        </div>
        </div>
        </div>




      <div className="container">
        {/* Tab Navigation */}
        <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link pb-3 ${activeTab === 'activepost' ? 'active' : ''}`}
              id="activepost-tab"
              onClick={() => handleTabChange('activepost')}
            >
              Edit Profile
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className={`nav-link pb-3 ${activeTab === 'inactivepost' ? 'active' : ''}`}
              id="inactivepost-tab"
              onClick={() => handleTabChange('inactivepost')}
            >
              Change Password
            </button>
          </li>


          <li className="nav-item">
              <button className={`nav-link ${activeTab === "deleteCompany" ? "active" : ""}`} onClick={() => handleTabChange("deleteCompany")}>
                Delete Company
              </button>
            </li>


          


        </ul>

        <div className="tab-content row mb-5" id="myTabContent">

          <div className={`tab-pane col-lg-12 mt-4 fade ${activeTab === 'activepost' ? 'show active' : ''}`} id="activepost" role="tabpanel">
            <div className="form-step card p-5 mt-3 shadow-sm rounded-4 fade-in">
              <div className="d-flex flex-row align-items-center mb-4 justify-content-between">
                <div className='js-mn-title flex-grow-1'>
                  <h3 className='fs-4 p-0 m-0 pb-2'>Personl Information</h3>
                </div>
              </div>
              <div className="mb-4">
                <label className="form-label">Full Name</label>
                <input
                  type="text" value="Madhav R"
                  className="form-control" />
              </div>
              <div className="mb-4">
                <label className="form-label">Email Address</label>
                <input
                  value="madhav.k@veritis.com"
                  type="email"
                  className="form-control"

                />
              </div>

              <div className="mb-4">
                <label className="form-label">Phone Number</label>
                <input
                  value=""
                  type="tel"
                  className="form-control"

                />
              </div>

              <div className="mb-4">
                <label className="form-label">Profile Image</label>
                <input
                  type="file"
                  className="form-control"
                />
              </div>

      <div className='d-flex'>
              <button type="button" className="btn mt-3 px-5 py-3 text-primary btn-outline-primary me-4">
                Cancel
              </button>
              <button type="button" className="btn mt-3 px-5 py-3 btn-primary">
                Update
              </button>
              </div>
            </div>

          </div>




          <div className={`tab-pane mt-4 col-lg-12 fade ${activeTab === 'inactivepost' ? 'show active' : ''}`} id="inactivepost" role="tabpanel">
          <div className="form-step card p-5 mt-3 shadow-sm rounded-4 fade-in">
          <div className="d-flex flex-row align-items-center mb-4 justify-content-between">
                <div className='js-mn-title flex-grow-1 mt-3'>
                  <h4 className='fs-5 pb-2'>Update Password</h4>
                </div>
              </div>
          <div className='mb-4'>
          <label className="form-label">New Password</label>
          <div className="input-group">
      <input className="form-control m-0"
        type="password"
        placeholder="Enter your password"
      />
      <button type='button' className="toggle-icon input-group-text">
      <FaRegEyeSlash />
      </button>
    </div>
    </div>
    <div className='mb-4'>
    <label className="form-label">Confirm Password</label>
    <div className="input-group mb-4">
      <input className="form-control m-0"
        type="password"
        placeholder="Enter your password"
      />
      <button type='button' className="toggle-icon input-group-text">
      <FaRegEyeSlash />
      </button>
    </div>
    </div>

    <div className='d-flex'>
              <button type="button" className="btn px-5 py-3 text-primary btn-outline-primary me-4">
                Cancel
              </button>
              <button type="button" className="btn px-5 py-3 btn-primary">
                Update
              </button>
              </div>
          </div>
        </div>




        {activeTab === "deleteCompany" && (
  <div className={`tab-pane mt-4 col-lg-12 fade ${activeTab === 'deleteCompany' ? 'show active' : ''}`} id="deleteCompany" role="tabpanel">
    <div className="form-step card p-5 mt-3 shadow-sm rounded-4 fade-in">
      <div className="d-flex flex-row align-items-center mb-4 justify-content-between">
        <div className='js-mn-title flex-grow-1 mt-3'>
          <h4 className='fs-5 pb-2'>Company Profiles</h4>
        </div>
      </div>

      {companies.map((company) => (
        <div key={company.id} className="card p-4 mb-3 border rounded-4">
          <div className="d-flex align-items-center">
            <img src={company.logo} alt={company.title} className="me-3 border rounded p-2" width="100" height="100" />
            <div className="w-100">
              <h5>
                <NavLink to="/CompanyProfile" className="text-black text-decoration-none">
                  {company.title}
                </NavLink>
              </h5>
              <p className="text-muted small">{company.tagline}</p>
              <button type="button" className="btn btn-danger btn-sm" onClick={() => { setShowModal(true); setSelectedCompany(company); }}>
                <FaTrash /> Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)}






      </div>
    </div>















    </div>
          <Footer />



          <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete <strong>{selectedCompany?.title}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => handleDelete(selectedCompany?.id)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>


      </>
  );
};

export default AccountSettings;